import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
//import { EnfermeraPage } from 'src/app/models/entidad-page.interface';
import { BusqUsuario, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-administrador-enfermeras',
  templateUrl: './administrador-enfermeras.component.html',
  styleUrls: ['./administrador-enfermeras.component.scss']
})
export class AdministradorEnfermerasComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  busquedaForm!: FormGroup;
  //enfermerasPageInformacion: HttpPaginacion<EnfermeraPage> | undefined;
  //enfermeraPage: EnfermeraPage[] = [];
  enfermerasPageInformacion: HttpPaginacionBusqueda<BusqUsuario> | undefined;
  enfermeraPage: BusqUsuario[] = [];

  constructor(private administradorService: AdministradorService, private fb: FormBuilder) {
    this.busquedaForm = this.crearFormBusqueda();
    this.obtenerInformacion(1);
  }

  onSubmit(): void {
    this.obtenerInformacion(1);
  }

  crearFormBusqueda(): FormGroup {
    return this.fb.group({
      nombre: [''],
      apellido_paterno: [''],
      apellido_materno: ['']
    });
  }

  obtenerInformacion(page: number): void {
    /* this.administradorService.enfermeras(page)
       .subscribe({
         next: (resp) => {
           this.enfermerasPageInformacion = resp;
           // this.enfermeraPage = resp.data;
 
           this.first = (resp.current_page - 1) * resp.per_page;
           this.rows = resp.per_page;
           this.totalRecords = resp.total;
         },
         error: (err) => console.log(err)
       });*/

    const busqueda = this.busquedaForm.value;
    /*  const filters = {};
      Object.entries(busqueda).forEach(([k, v]) => {
        if (v != null && v !== '') {
          Object.defineProperty(filters, k, { value: v });
        }
      });
    
  */
    this.administradorService
      .busquedaEnfermeras(busqueda, page)
      .subscribe({
        next: (resp) => {
          this.enfermerasPageInformacion = resp;
          this.enfermeraPage = resp.data;
          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => { console.log(err.error) }
      })

  }
  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
  }
  exportExcel(): void {
    const url = environment.urlBackPublic + environment.xlsxs.datosGeneralesEnfermeras;
    window.open(url, "_blank");
  }
}
